// Just the icon (the three-bar / B1 monogram), no wordmark.
// Used in the top bar where space is tight and the wordmark would crowd nav.
//
// The shape is a stylised "1" formed by three horizontal green bars enclosed
// in a green frame — matching the binaryone.co.ke favicon / app icon.

export default function LogoMark({ className = 'h-8 w-8' }) {
  return (
    <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" className={className} aria-label="Binary One Solutions">
      {/* white card behind the mark so it pops on dark headers */}
      <rect x="2" y="2" width="60" height="60" rx="10" fill="#FFFFFF" />
      {/* three horizontal bars — the binary motif */}
      <rect x="14" y="18" width="36" height="6" rx="2" fill="#00A651" />
      <rect x="14" y="29" width="36" height="6" rx="2" fill="#00A651" />
      <rect x="14" y="40" width="36" height="6" rx="2" fill="#00A651" />
      {/* diagonal slash forming the "1" */}
      <rect x="36" y="6" width="6" height="52" rx="2" fill="#0F0F0F" transform="rotate(20 39 32)" />
    </svg>
  );
}
